import Joi from '@hapi/joi'

export const CustomerLeafWiseCollectionReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    factoryID: Joi.number().invalid(0).required().label("Factory").messages({
        "any.invalid": `Select Factory`,
        "any.required": `Factory required`
    }),
    routeID:Joi.number().allow("", null).label("Route"),
    collectionTypeID: Joi.number().allow("", null).label("Collection Type"),
    regNo: Joi.string().allow("", null).label("Reg Number"),
    fromDate: Joi.string().invalid("").label("From Date"),
    toDate: Joi.string().invalid("").label("To Date")
}